import React from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { blogPosts } from "./BlogData";
import { Link } from "react-router-dom";
import GoogleAd from "../ads/GoogleAd";


const personalBlogs = blogPosts.filter(blog => blog.type === "personal");
const techBlogs = blogPosts.filter(blog => blog.type === "tech");

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

function Blog() {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container className="mt-5 pt-5 pb-5" style={{ maxWidth: "1000px", color: "#ffffff" }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <GoogleAd adSlot="5678184118" />
        <h1 className="text-center mb-4">My Blog</h1>
        <div className="text-center mb-5">
          <Button variant="outline-light" className="me-3" onClick={() => scrollToSection("personal")}>
            Personal
          </Button>
          <Button variant="outline-light" onClick={() => scrollToSection("tech")}>
            Tech
          </Button>
        </div>
      </motion.div>

      {/* Personal Section */}
      <motion.div
        id="personal"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2 className="mb-4 text-decoration-underline">📌 Personal Blogs</h2>
        <Row>
          {personalBlogs.map((post) => (
            <Col md={4} className="mb-4" key={post.id}>
              <motion.div
                variants={cardVariants}
                whileHover={{ scale: 1.03, boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.2)" }}
                transition={{ type: "spring", stiffness: 120 }}
              >
                <Card bg="dark" text="light" className="h-100 shadow">
                  <Card.Body>
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{post.date}</Card.Subtitle>
                    <Card.Text>{post.summary}</Card.Text>
                    <Link to={`/blog/${post.id}`}>
                      <Button variant="outline-light" size="sm">Read More</Button>
                    </Link>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </motion.div>

      {/* Tech Section */}
      <motion.div
        id="tech"
        className="mt-5"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2 className="mb-4 text-decoration-underline">💻 Tech Blogs</h2>
        <Row>
          {techBlogs.map((post) => (
            <Col md={4} className="mb-4" key={post.id}>
              <motion.div
                variants={cardVariants}
                whileHover={{ scale: 1.03, boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.2)" }}
                transition={{ type: "spring", stiffness: 120 }}
              >
                <Card bg="dark" text="light" className="h-100 shadow">
                  <Card.Body>
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{post.date}</Card.Subtitle>
                    <Card.Text>{post.summary}</Card.Text>
                    <Link to={`/blog/${post.id}`}>
                      <Button variant="outline-light" size="sm">Read More</Button>
                    </Link>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
        <GoogleAd adSlot="3961777764" adFormat="autorelaxed" />
      </motion.div>
      
    </Container>
    
  );
}

export default Blog;
